import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { LoadingBarState } from './store/loading-bar/loading-bar.state';
import { Observable } from 'rxjs';
import { HomeState } from './store/home/home.state';
import { UserDto } from './model/user/user-dto';
import { SessionService } from './shared/services/session.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { SessionInfo } from './model/session.info';
import { SubjectService } from './shared/services/subject/subject.service';
import { SdkInitText } from './model/user/sdk-init-text';
import { AmountPipe } from './shared/pipes/amount.pipe';

@Component({
  selector: 'pa-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'web-frontend';

  show: boolean;
  deadline = null;
  brandIcon: string;
  sessionInfo: SessionInfo = null;
  sdkInitTexts: SdkInitText[];
  trackingId: string;
  amount: string;
  returnUrl: string;
  loginWebSdk: boolean;
  getResultUrl: string;
  timeout: boolean;
  amountPipe: AmountPipe = new AmountPipe();
  sessionInfoServiceRequestCheck: boolean;

  @Select(LoadingBarState.status) loadingStatus$: Observable<boolean>;
  @Select(HomeState.userDetail) showHeader$: Observable<UserDto>;

  constructor(private router: Router, private route: ActivatedRoute, private sessionService: SessionService, private subjectService: SubjectService) {
    this.trackingId = window.location.href.substr(window.location.href.lastIndexOf('/')+1), window.location.href.lastIndexOf('?');
    this.subjectService.validationSubject$.subscribe(user => {
      this.show = user != null;
      this.sdkInitTexts = user.sdkInitTexts;
      this.sessionInfo = user.sessionInfo;
      this.brandIcon = user.sessionInfo.brandIcon;
      this.amount = this.amountPipe.transform(Number(user.firstAmount) / 100);
      this.returnUrl = user.returnUrl;
      this.loginWebSdk = user.loginWebSdk;
      this.getResultUrl = user.getResultUrl;
      this.giveCountdownTime(user.sessionInfo.duration);
    });
    this.router.events.subscribe(value => {
      if (this.sessionInfo === null && value instanceof NavigationStart && !value.url.startsWith('/home')) {
        this.sessionService.getSessionInfo(this.trackingId)
          .subscribe(
            response => {
              this.sessionInfoServiceRequestCheck = true;
              this.show = response != null;
              this.sdkInitTexts = response.sdkInitTexts;
              this.sessionInfo = response;
              this.brandIcon = response.brandIcon;
              this.amount = this.amountPipe.transform(Number(response.amount) / 100);
              this.returnUrl = response.returnUrl;
              this.giveCountdownTime(response.duration);
            },
            error => {
              this.router.navigate(['/result/error', this.trackingId]);
            }
          );
      }
    });
  }

  ngOnInit() {
  }

  giveCountdownTime(duration: number) {
    if (duration > 0) {
      this.deadline = Date.now() + duration;
    }
  }

}
